// React
import React from 'react';
// External
import { withRouter } from 'react-router-dom';
// Styles
import './styles.scss';

/**
 * @param {Object} props.className - Class to be applied to the button
 * @param {Object} props.controlClassName - Class to be applied to the button
 * @param {Function} props.options - On click function handler
 */
class Selector extends React.Component {
    onChange(value, obj) {
        this.props.onChange(value, obj);
    }

    render() {
        return (
            <div className="input">
                <input
                    type="file"
                    className={this.props.className}
                    name={this.props.name}
                    onChange={(value, obj) => {
                        this.onChange(value, obj);
                    }}
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}

export default withRouter(Selector);
